module.exports = require("base64-stream");